import React from 'react';
import { observer } from 'mobx-react-lite';

import { fighterSectionBorderColor, fightersList } from '../../enums/uiConfig';

export const FightersStandardHeader = observer(
  ({ t, currentFighterSection, setActiveCurrentSection, betData }) => {
    /* ADD CLASS "type-orange, type-green, type-pink" */

    return (
      <div
        className={`bet-fighter-head-row ${fighterSectionBorderColor[currentFighterSection]} type-1`}
      >
        {/* ADD CLASS " active " */}
        {betData.map((item) => (
          <div
            className={`fighter-top-items ${
              currentFighterSection === item.fighterNumber ? 'active' : ''
            }`}
            key={item.fighterNumber}
            onClick={() => setActiveCurrentSection(item.fighterNumber)}
          >
            <div className='box-for-bg'>
              <div className='bg-inside' />
            </div>
            <button className='fighter-top-button'>
              <span
                className={`fighter-top-btn-text fighter-text${
                  fightersList[item.fighterNumber].jetNumber
                }`}
              >
                {t(fightersList[item.fighterNumber].jetName)}
              </span>
              {/* <i */}
              {/*  className={`ui-lib-tabs-x top-tab-x${fightersList[item.fighterNumber].jetNumber}`} */}
              {/* /> */}
              <span className='fighters-x-icon' />
            </button>
          </div>
        ))}
      </div>
    );
  }
);
